import React, { Component } from 'react'
import { connect } from 'react-redux'
import Trash from 'react-icons/lib/md/delete'
import acc from 'accounting'

class ListEnrolledItem extends Component {

  _onRemove = () => {
    this.props.onRemove(this.props.item.get('id'))
  }

  render() {
    const { item } = this.props

    return (
      <tr>
        <td><button onClick={this._onRemove} className="btn-inline btn-icon"><Trash /></button></td>
        <td><code>{item.get('subject_code')}</code></td>
        <td>{item.get('section')}</td>
        <td>{item.get('subject_name')}</td>
        <td><small>{item.get('schedule')}</small></td>
        <td className="text-right">{acc.formatNumber(item.get('lec_units'), 1)}</td>
        <td className="text-right">{acc.formatNumber(item.get('lab_units'), 1)}</td>
        <td className="text-right">{acc.formatNumber(item.get('units'), 1)}</td>
        <td>
          <small>{item.get('instructor_name')}</small>
        </td>
      </tr>
    )
  }
}

export default connect()(ListEnrolledItem)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/Modify/list-enrolled-item.js